export const defaultHtml = `
    <h1>Plugins</h1>
    <p>Type @, and keep typing to connect plugins to this part of your workspace:&nbsp;</p>
    <p>
        <plugin code="alias">Aliases</plugin>
    </p>
    <hr>
    <h2>References</h2>
    <p>Data plugins will look for familiar links here, and try to make the content they point to browsable</p>
    <ul>
        <li>Replace me with an URL to some data</li>
    </ul>
    <hr>
    <h2>Aliases</h2>
    <p>The Aliases plugin will look for definitions here, and let you interact with them in your documents</p>
    <table style="min-width: 256px;">
        <thead>
            <tr>
                <th>Keyword</th>
                <th>Content</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>iQx</td>
                <td>
                    <img src="https://assets.iqx.no/docs/iqx-logo.png">
                </td>
            </tr>
        </tbody>
    </table>
`;
